import {
  HOME_CHECK_CLONING_BEGIN,
  HOME_CHECK_CLONING_SUCCESS,
  HOME_CHECK_CLONING_FAILURE,
  HOME_CHECK_CLONING_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { builderAuthHeader, errorLogOut } from '../../common/utils/auth';

export function checkCloning(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_CHECK_CLONING_BEGIN,
    });
    const { projectId } = args;
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}projects/${projectId}/check-cloning`,
        {},
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CHECK_CLONING_SUCCESS,
            data: res.data,
          });
          resolve(res);
          if (res.data.status === 'Failed') {
            toast.error(res.data.message);
          }
        },
        (err) => {
          dispatch({
            type: HOME_CHECK_CLONING_FAILURE,
            data: { error: err },
          });
          reject(err);
          if (err.response.status === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Session Expired',
            }).then((result) => {
              if (result.value) {
                errorLogOut();
              }
            });
          }
        },
      );
    });

    return promise;
  };
}

export function dismissCheckCloningError() {
  return {
    type: HOME_CHECK_CLONING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CHECK_CLONING_BEGIN:
      return {
        ...state,
        checkCloningPending: true,
        checkCloningError: null,
      };

    case HOME_CHECK_CLONING_SUCCESS:
      return {
        ...state,
        checkCloningPending: false,
        checkCloningError: null,
        checkCloning: action.data,
      };

    case HOME_CHECK_CLONING_FAILURE:
      return {
        ...state,
        checkCloningPending: false,
        checkCloningError: action.data.error,
      };

    case HOME_CHECK_CLONING_DISMISS_ERROR:
      return {
        ...state,
        checkCloningError: null,
      };

    default:
      return state;
  }
}
